import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent, HttpHeaders,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from './app.service';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class RequestsInterceptor implements HttpInterceptor {

	constructor(private appService: AppService, private route: ActivatedRoute){}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const newHeaders = {
			// ...(this.appService.appData.value ? {'X-Domain-Id': this.appService.domainId} : null),
			'X-Requested-With': 'XMLHttpRequest',
			'Accept': 'application/json'
		};
		const lang = localStorage.getItem('locale');
		if(lang) newHeaders['X-LANG'] = lang
		const newRequest = request.clone({
			setHeaders: newHeaders,
			setParams: {
				...(this.appService.appData.value ? {'domain_id': this.appService.domainId} : null),
			},
			withCredentials: true
		});
		return next.handle(newRequest);
	}
}
